import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import {
  IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel,
  IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel,
  IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoPapelTrabalhoModel,
  IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoArquivoModel,
  IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoPapelTrabalhoArquivoModel,
  IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoRiscoModel,
  IMatrizRiscoControleRiscosModel,
  IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoControleModel,
  IMatrizRiscoControleAssociadosModel,
  IOsaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoModel,
  IOsaExecucaoProgramaTrabalhoQuestaoIncidentalConsequenciaModel,
  IOsaExecucaoProgramaTrabalhoQuestaoIncidentalControleModel
} from "./../../../../../models/osa-execucao-programa-trabalho.model";
import { OsaExecucaoProgramaTrabalhoService } from "./../../../../../services/osa-execucao-programa-trabalho.service";
import Swal from "sweetalert2";
import { AuthService } from "./../../../../../services/auth.service";
import { BaseFormComponent } from "../../../../../shared/components/base-form/base-form.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { IOsaExecucaoPapelTrabalhoArquivo } from "../../../../../models/osa-execucao-papel-trabalho.model";
import { OsaExecucaoPapelTrabalhoService } from "../../../../../services/osa-execucao-papel-trabalho.service";
import { OsaExecucaoAbaFolhaTesteProgTrabQuestNovaConstaComponent } from "../osa-execucao-aba-folha-teste-prog-trab-quest-nova-consta/osa-execucao-aba-folha-teste-prog-trab-quest-nova-consta.component";

@Component({
  selector: 'app-osa-execucao-aba-folha-teste-prog-trab-quest-resp-consta',
  templateUrl: './osa-execucao-aba-folha-teste-prog-trab-quest-resp-consta.component.html',
  styleUrls: ['./osa-execucao-aba-folha-teste-prog-trab-quest-resp-consta.component.scss']
})


export class OsaExecucaoAbaFolhaTesteProgTrabQuestRespConstaComponent extends BaseFormComponent implements OnInit {

  @ViewChild("tabelaEvidenciaPaginator", { static: true })
  tabelaEvidenciaPaginator: MatPaginator;
  @ViewChild("tabelaEvidenciaSort", { static: true })
  tabelaEvidenciaSort: MatSort;

  @ViewChild("tabelaRiscoPaginator", { static: true })
  tabelaRiscoPaginator: MatPaginator;
  @ViewChild("tabelaRiscoSort", { static: true })
  tabelaRiscoSort: MatSort;

  @ViewChild("tabelaControlePaginator", { static: true })
  tabelaControlePaginator: MatPaginator;
  @ViewChild("tabelaControleSort", { static: true })
  tabelaControleSort: MatSort;

  public model = this.createModel();

  public dataSourceEvidencias = new MatTableDataSource<IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoPapelTrabalhoModel>([]);
  public evidenciasAnexadasQuestao: IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel[] = [];
  public evidenciaSelecionada: IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel = {} as IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel;

  public dataSourceRiscos = new MatTableDataSource<IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoRiscoModel>([]);
  public riscoSelecionado: IMatrizRiscoControleRiscosModel = {} as IMatrizRiscoControleRiscosModel;
  public riscoSelecionadoQI: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoModel = {} as IOsaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoModel;

  public dataSourceControles = new MatTableDataSource<IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoControleModel>([]);
  public controleSelecionado: IMatrizRiscoControleAssociadosModel = {} as IMatrizRiscoControleAssociadosModel;
  public controleSelecionadoQI: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalControleModel = {} as IOsaExecucaoProgramaTrabalhoQuestaoIncidentalControleModel;

  public tituloModal = "";
  public visualizar = false;
  public id: number = 0;

  public unidadeGestoraId: number = 0;
  public planejamentoId: number = 0;
  public questaoPlanejamentoId: number = 0;
  public observacao: string = "";
  public osaExecucaoProgramaTrabalhoId: number = 0;
  public identificador: string = "C.01";
  public isQuestaoIncidental: boolean = false;
  public osaExecucaoProgramaTrabalhoQuestaoId: number = 0;
  public novoRiscoDescricao: string = '';
  public novoControleDescricao: string = '';

  constructor(
    public route: ActivatedRoute,
    public toastr: ToastrService,
    public router: Router,
    public localeService: BsLocaleService,
    public matDialog: MatDialog,
    public osaExecucaoProgramaTrabalhoService: OsaExecucaoProgramaTrabalhoService,
    public osaExecucaoPapelTrabalhoService: OsaExecucaoPapelTrabalhoService,
    public authService: AuthService,
    private dialogRef: MatDialogRef<OsaExecucaoAbaFolhaTesteProgTrabQuestRespConstaComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    super(route, toastr, router, localeService, matDialog);

    console.log(data)
    this.id = data?.id;
    this.visualizar = data?.visualizar;
    this.tituloModal = data?.titulo;

    this.unidadeGestoraId = data?.unidadeGestoraId;
    this.planejamentoId = data?.planejamentoId;
    this.questaoPlanejamentoId = data?.questaoPlanejamentoId;
    this.observacao = data?.observacao;
    this.osaExecucaoProgramaTrabalhoId = data?.osaExecucaoProgramaTrabalhoId;
    this.osaExecucaoProgramaTrabalhoQuestaoId = data?.osaExecucaoProgramaTrabalhoQuestaoId;
    this.isQuestaoIncidental = !data?.questaoPlanejamentoId || data?.questaoPlanejamentoId == undefined;

    if (data?.identificador) {
      this.identificador = data.identificador;
      this.model.identificador = data.identificador;
    }

    if (data?.element) {
      this.model = data?.element;
    }

    if (data?.evidencias) {
      this.evidenciasAnexadasQuestao = data?.evidencias;
    }
  }

  ngOnInit(): void {
    this.carregarDataSources();
  }

  private createModel(): IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel {
    return {
      id: 0,
      osaExecucaoProgramaTrabalhoQuestaoId: 0,
      identificador: '',
      titulo: '',
      descricao: '',
      tipo: 0,
      tipoDesc: '',
      criteriosInfrigidos: '',
      situacaoEncontrada: '',
      evidencias: [],
      riscos: [],
      controles: []
    };
  }

  public carregarDataSources() {

    this.dataSourceEvidencias.data = this.model?.evidencias;
    this.dataSourceEvidencias.paginator = this.tabelaEvidenciaPaginator;
    this.dataSourceEvidencias.sort = this.tabelaEvidenciaSort;
    this.dataSourceEvidencias.sortingDataAccessor = this.sortingEvidenciaDataAccessor;

    this.dataSourceRiscos.data = this.model?.riscos;
    this.dataSourceRiscos.paginator = this.tabelaRiscoPaginator;
    this.dataSourceRiscos.sort = this.tabelaRiscoSort;
    this.dataSourceRiscos.sortingDataAccessor = this.sortingRiscoDataAccessor;

    this.dataSourceControles.data = this.model?.controles;
    this.dataSourceControles.paginator = this.tabelaControlePaginator;
    this.dataSourceControles.sort = this.tabelaControleSort;
    this.dataSourceControles.sortingDataAccessor = this.sortingControleDataAccessor;
  }

  public sortingEvidenciaDataAccessor = (item, property) => {
    switch (property) {
      case "nome":
        return item.osaExecucaoPapelTrabalho.nomePapel;
      case "link":
        return item.osaExecucaoPapelTrabalho.link;
      default:
        return item[property];
    }
  };

  public sortingRiscoDataAccessor = (item, property) => {
    switch (property) {
      case "descricao":
        return item.osaExecucaoProgramaTrabalhoQuestaoIncidentalRisco?.descricao
          ?? item.matrizRiscoControleRiscos?.descricaoRisco
          ?? item.descricaoRiscoAvulso;
      default:
        return item[property];
    }
  };
  public sortingControleDataAccessor = (item, property) => {
    switch (property) {
      case "descricao":
        return item.osaExecucaoProgramaTrabalhoQuestaoIncidentalControle?.descricao
          ?? item.matrizRiscoControleAssociados?.descricao
          ?? item.descricaoControleAvulso;
      default:
        return item[property];
    }
  };

  public salvar() {

    if (!this.model.titulo) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Selecione ou cadastre uma constatação!",
      });
      return;
    }

    if (this.model.riscos.length <= 0) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Riscos Associados não foram vinculados!",
      });
      return;
    }

    if ((this.observacao === "" || this.observacao === undefined) && this.model.evidencias.length <= 0) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Na falta de observações da avaliação da questão, o campo Evidências Vinculadas se torna obrigatório!",
      });
      return;
    }

    this.dialogRef.close(this.model);
  }

  public async exibirModalConstatacao() {

    try {
      const res = await this.osaExecucaoProgramaTrabalhoService.obterProgramaTrabalhoQuestaoConstatacaoPorProgramaTrabalho(this.osaExecucaoProgramaTrabalhoId);
      console.log(res);
      if (res.sucesso) {

        var columns: { columnDef: string, header: string }[];

        columns = [
          {
            columnDef: 'id',
            header: 'Identif.'
          },
          {
            columnDef: 'titulo',
            header: 'Título'
          },
          {
            columnDef: 'tipoDesc',
            header: 'Tipo'
          },
        ];

        const modal = this.exibirModal("Selecionar Constatação", res.dados, false, columns);
        modal.afterClosed().subscribe((data) => {
          if (data) {
            console.log(data);
            //=> carrega os dados do objeto que foi selecionado
            this.model.identificador = data.identificador;
            this.model.titulo = data.titulo;
            this.model.descricao = data.descricao;
            this.model.tipo = data.tipo;
            this.model.tipoDesc = data.tipoDesc;
            this.model.criteriosInfrigidos = data.criteriosInfrigidos;
            this.model.situacaoEncontrada = data.situacaoEncontrada;
          }
        });
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    } catch (err) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        text: err.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  public cadastrarConstatacao() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-constatacao";
    dialogConfig.width = "60%";
    dialogConfig.height = "80%";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = false;
    dialogConfig.data = {
      titulo: `Adicionar Constatação`,
      model: this.model,
    };

    const modal = this.matDialog.open(OsaExecucaoAbaFolhaTesteProgTrabQuestNovaConstaComponent, dialogConfig);
    modal.afterClosed().subscribe((data) => {

      if (data) {
        console.log(data);
        //=> carrega os dados do objeto que foi cadastrado
        this.model.identificador = this.identificador;
        this.model.titulo = data.titulo;
        this.model.descricao = data.descricao;
        this.model.tipo = data.tipo;
        this.model.tipoDesc = data.tipoDesc;
        this.model.criteriosInfrigidos = data.criteriosInfrigidos;
        this.model.situacaoEncontrada = data.situacaoEncontrada;
      }
    });
  }

  public addRiscoAvulso() {
    if (!this.novoRiscoDescricao || !this.novoRiscoDescricao.trim()) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Informe a descrição do novo risco!",
      });
      return;
    }

    const novoRisco: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoRiscoModel = {
      id: 0,
      osaExecucaoProgramaTrabalhoQuestaoConstatacaoId: this.id,
      matrizRiscoControleRiscosId: null,
      matrizRiscoControleRiscos: null,
      osaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoId: null,
      osaExecucaoProgramaTrabalhoQuestaoIncidentalRisco: null,
      descricaoRiscoAvulso: this.novoRiscoDescricao.trim()
    };

    this.model.riscos.push(novoRisco);
    this.dataSourceRiscos.data = [...this.model.riscos];
    this.novoRiscoDescricao = '';
  }

  public addControleAvulso() {
    if (!this.novoControleDescricao || !this.novoControleDescricao.trim()) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Informe a descrição do novo controle!",
      });
      return;
    }

    const novoControle: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoControleModel = {
      id: 0,
      osaExecucaoProgramaTrabalhoQuestaoConstatacaoId: this.id,
      matrizRiscoControleAssociadosId: null,
      matrizRiscoControleAssociados: null,
      osaExecucaoProgramaTrabalhoQuestaoIncidentalControleId: null,
      osaExecucaoProgramaTrabalhoQuestaoIncidentalControle: null,
      descricaoControleAvulso: this.novoControleDescricao.trim()
    };

    this.model.controles.push(novoControle);
    this.dataSourceControles.data = [...this.model.controles];
    this.novoControleDescricao = '';
  }

  public async exibirModalEvidencia() {

    try {

      if (this.evidenciasAnexadasQuestao.length > 0) {
        var columns: { columnDef: string, header: string }[];
        columns = [
          {
            columnDef: 'nomePapel',
            header: 'Nome do Papel'
          }
        ];

        const modal = this.exibirModal("Selecionar Evidências", this.evidenciasAnexadasQuestao, false, columns);
        modal.afterClosed().subscribe((data) => {
          if (data) {
            //=> carrega os dados do objeto que foi selecionado
            this.evidenciaSelecionada = data;
          }
        });
      }
      else {
        Swal.fire({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          icon: "warning",
          text: "Não existem evidências vinculadas na questão!",
        });
        return;
      }

    } catch (err) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        text: err.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  public addEvidencia() {

    if (!this.evidenciaSelecionada.id) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Selecione a Evidência para incluir!",
      });
      return;
    }

    //-> antes de adicionar a evidencia, verifica se ja existe
    const idx = this.model.evidencias?.findIndex(x => x.osaExecucaoPapelTrabalhoId === this.evidenciaSelecionada.osaExecucaoPapelTrabalhoId);
    if (idx !== undefined && idx > -1) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Evidência já foi relacionada!",
      });
      return;
    }

    // adiciona na grade

    //-> cria uma lista com os arquivos selecionados
    var arquivosEvidencia: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoPapelTrabalhoArquivoModel[] = [];

    if (this.evidenciaSelecionada.arquivos?.length > 0) {

      this.evidenciaSelecionada.arquivos.forEach((arq: IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoArquivoModel) => {

        const novoArquivo: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoPapelTrabalhoArquivoModel = {
          id: 0,
          osaExecucaoProgramaTrabalhoQuestaoConstatacaoPapelTrabalhoId: 0,
          osaExecucaoPapelTrabalhoArquivoId: arq.osaExecucaoPapelTrabalhoArquivo.id,
          osaExecucaoPapelTrabalhoArquivo: {
            id: arq.osaExecucaoPapelTrabalhoArquivo.id,
            osaExecucaoPapelTrabalhoId: arq.osaExecucaoPapelTrabalhoArquivo.osaExecucaoPapelTrabalhoId,
            nome: arq.osaExecucaoPapelTrabalhoArquivo.nome,
            tipo: arq.osaExecucaoPapelTrabalhoArquivo.tipo,
            arquivo: arq.osaExecucaoPapelTrabalhoArquivo.arquivo
          }
        };
        arquivosEvidencia.push(novoArquivo);
      });
    }


    const novaEvidencia: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoPapelTrabalhoModel = {
      id: 0,
      osaExecucaoProgramaTrabalhoQuestaoConstatacaoId: this.id,
      osaExecucaoPapelTrabalhoId: this.evidenciaSelecionada.osaExecucaoPapelTrabalhoId,
      osaExecucaoPapelTrabalho: this.evidenciaSelecionada.osaExecucaoPapelTrabalho,
      arquivos: arquivosEvidencia
    };

    this.model.evidencias.push(novaEvidencia);
    this.dataSourceEvidencias.data = [...this.model.evidencias];
    this.evidenciaSelecionada = {} as IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel;
  }


  public excluirEvidencia(index: number) {
    Swal.fire({
      title: "Excluir Evidência?",
      text: "Confirma exclusão da evidência?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then(res => {

      if (res.isConfirmed) {
        this.model.evidencias?.splice(index, 1);
        this.dataSourceEvidencias.data = [...this.model.evidencias];
      }
    });
  }

  public download(arquivo: IOsaExecucaoPapelTrabalhoArquivo) {
    this.osaExecucaoPapelTrabalhoService.downloadAnexo(arquivo.id).then((res) => {
      if (res.sucesso) {
        const link = document.createElement("a");
        link.href = res.dados.toString(); 0
        link.download = arquivo.nome;
        link.click();
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    })
  }

  public async exibirModalRisco() {

    try {

      const res = await this.osaExecucaoProgramaTrabalhoService.obterRiscosPorPlanejamentoUgQuestao(this.planejamentoId, this.unidadeGestoraId, this.questaoPlanejamentoId);

      if (res.sucesso) {

        var columns: { columnDef: string, header: string }[];

        columns = [
          {
            columnDef: 'id',
            header: 'Id'
          },
          {
            columnDef: 'descricaoRisco',
            header: 'Descrição'
          }
        ];

        const modal = this.exibirModal("Selecionar Risco", res.dados, false, columns);
        modal.afterClosed().subscribe((data) => {
          if (data) {
            //=> carrega os dados do objeto que foi selecionado
            this.riscoSelecionado = data;
          }
        });
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    } catch (err) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        text: err.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  public async exibirModalRiscoQI() {

    try {

      const res = await this.osaExecucaoProgramaTrabalhoService.obterProgramaTrabalhoQuestaoIncidentalRiscoPorProgramaTrabalhoQuestao(this.osaExecucaoProgramaTrabalhoQuestaoId);

      if (res.sucesso) {

        var columns: { columnDef: string, header: string }[];

        columns = [
          {
            columnDef: 'id',
            header: 'Id'
          },
          {
            columnDef: 'descricao',
            header: 'Descrição'
          }
        ];

        const modal = this.exibirModal("Selecionar Risco", res.dados, false, columns);
        modal.afterClosed().subscribe((data) => {
          if (data) {
            //=> carrega os dados do objeto que foi selecionado
            this.riscoSelecionadoQI = data;
          }
        });
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    } catch (err) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        text: err.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  public addRisco() {

    if (!this.riscoSelecionado.id) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Selecione o Risco para incluir!",
      });
      return;
    }

    //-> antes de adicionar o risco, verifica se ja existe
    const idx = this.model.riscos?.findIndex(x => x.matrizRiscoControleRiscosId === this.riscoSelecionado.id);
    if (idx !== undefined && idx > -1) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Risco já foi relacionado!",
      });
      return;
    }

    // adiciona na grade
    const novoRisco: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoRiscoModel = {
      id: 0,
      osaExecucaoProgramaTrabalhoQuestaoConstatacaoId: this.id,
      matrizRiscoControleRiscosId: this.riscoSelecionado.id,
      matrizRiscoControleRiscos: this.riscoSelecionado,
      osaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoId: null,
      osaExecucaoProgramaTrabalhoQuestaoIncidentalRisco: null,
      descricaoRiscoAvulso: null
    };

    this.model.riscos.push(novoRisco);
    this.dataSourceRiscos.data = [...this.model.riscos];
    this.riscoSelecionado = {} as IMatrizRiscoControleRiscosModel;
  }

  public addRiscoQI() {

    if (!this.riscoSelecionadoQI.id) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Selecione o Risco para incluir!",
      });
      return;
    }

    //-> antes de adicionar o risco, verifica se ja existe
    const idx = this.model.riscos?.findIndex(x => x.osaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoId === this.riscoSelecionadoQI.id);
    if (idx !== undefined && idx > -1) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Risco já foi relacionado!",
      });
      return;
    }

    // adiciona na grade
    const novoRisco: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoRiscoModel = {
      id: 0,
      osaExecucaoProgramaTrabalhoQuestaoConstatacaoId: this.id,
      matrizRiscoControleRiscosId: null,
      matrizRiscoControleRiscos: null,
      osaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoId: this.riscoSelecionadoQI.id,
      osaExecucaoProgramaTrabalhoQuestaoIncidentalRisco: this.riscoSelecionadoQI,
      descricaoRiscoAvulso: null
    };

    this.model.riscos.push(novoRisco);
    this.dataSourceRiscos.data = [...this.model.riscos];
    this.riscoSelecionadoQI = {} as IOsaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoModel;
  }

  public excluirRisco(index: number) {

    Swal.fire({
      title: "Excluir Risco?",
      text: "Confirma exclusão do Risco?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.isConfirmed) {
        this.model.riscos?.splice(index, 1);
        this.dataSourceRiscos.data = [...this.model.riscos];
      }
    });
  }

  public async exibirModalControle() {

    try {

      const res = await this.osaExecucaoProgramaTrabalhoService.obterControlesPorPlanejamentoUgQuestao(this.planejamentoId, this.unidadeGestoraId, this.questaoPlanejamentoId);

      if (res.sucesso) {

        var columns: { columnDef: string, header: string }[];

        columns = [
          {
            columnDef: 'id',
            header: 'Id'
          },
          {
            columnDef: 'descricao',
            header: 'Descrição'
          }
        ];

        const modal = this.exibirModal("Selecionar Controle", res.dados, false, columns);
        modal.afterClosed().subscribe((data) => {
          if (data) {
            //=> carrega os dados do objeto que foi selecionado
            this.controleSelecionado = data;
          }
        });
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    } catch (err) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        text: err.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  public async exibirModalControleQI() {

    try {

      const res = await this.osaExecucaoProgramaTrabalhoService.obterProgramaTrabalhoQuestaoIncidentalControlePorProgramaTrabalhoQuestao(this.osaExecucaoProgramaTrabalhoQuestaoId);

      if (res.sucesso) {

        var columns: { columnDef: string, header: string }[];

        columns = [
          {
            columnDef: 'id',
            header: 'Id'
          },
          {
            columnDef: 'descricao',
            header: 'Descrição'
          }
        ];

        const modal = this.exibirModal("Selecionar Controle", res.dados, false, columns);
        modal.afterClosed().subscribe((data) => {
          if (data) {
            //=> carrega os dados do objeto que foi selecionado
            this.controleSelecionadoQI = data;
          }
        });
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    } catch (err) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        text: err.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }


  public addControle() {

    if (!this.controleSelecionado.id) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Selecione o Controle para incluir!",
      });
      return;
    }

    //-> antes de adicionar o controle, verifica se ja existe
    const idx = this.model.controles?.findIndex(x => x.matrizRiscoControleAssociadosId === this.controleSelecionado.id);
    if (idx !== undefined && idx > -1) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Controle já foi relacionado!",
      });
      return;
    }

    // adiciona na grade
    const novoControle: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoControleModel = {
      id: 0,
      osaExecucaoProgramaTrabalhoQuestaoConstatacaoId: this.id,
      matrizRiscoControleAssociadosId: this.controleSelecionado.id,
      matrizRiscoControleAssociados: this.controleSelecionado,
      osaExecucaoProgramaTrabalhoQuestaoIncidentalControleId: null,
      osaExecucaoProgramaTrabalhoQuestaoIncidentalControle: null,
      descricaoControleAvulso: null
    };

    this.model.controles.push(novoControle);
    this.dataSourceControles.data = [...this.model.controles];
    this.controleSelecionado = {} as IMatrizRiscoControleAssociadosModel;
  }

  public addControleQI() {

    if (!this.controleSelecionadoQI.id) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Selecione o Controle para incluir!",
      });
      return;
    }

    //-> antes de adicionar o controle, verifica se ja existe
    const idx = this.model.controles?.findIndex(x => x.osaExecucaoProgramaTrabalhoQuestaoIncidentalControleId === this.controleSelecionadoQI.id);
    if (idx !== undefined && idx > -1) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Controle já foi relacionado!",
      });
      return;
    }

    // adiciona na grade
    const novoControle: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoControleModel = {
      id: 0,
      osaExecucaoProgramaTrabalhoQuestaoConstatacaoId: this.id,
      matrizRiscoControleAssociadosId: null,
      matrizRiscoControleAssociados: null,
      osaExecucaoProgramaTrabalhoQuestaoIncidentalControleId: this.controleSelecionadoQI.id,
      osaExecucaoProgramaTrabalhoQuestaoIncidentalControle: this.controleSelecionadoQI,
      descricaoControleAvulso: null
    };

    this.model.controles.push(novoControle);
    this.dataSourceControles.data = [...this.model.controles];
    this.controleSelecionadoQI = {} as IOsaExecucaoProgramaTrabalhoQuestaoIncidentalControleModel;
  }

  public excluirControle(index: number) {

    Swal.fire({
      title: "Excluir Controle?",
      text: "Confirma exclusão do Controle?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.isConfirmed) {
        this.model.controles?.splice(index, 1);
        this.dataSourceControles.data = [...this.model.controles];
      }
    });
  }


  public fechar() {
    this.dialogRef.close();
  }

}

